/**
 * 全局登录拦截 composable（Pinia store 包装）
 * 
 * 所有组件通过 useAuthGuard() 使用，内部用 Pinia store 保证响应式一致性
 */
import { useAuthGuardStore } from '@/stores/authGuard'

export function useAuthGuard() {
  const store = useAuthGuardStore()
  return {
    showLoginGuide: store.showLoginGuide,
    loginSource: store.loginSource,
    requireLogin: store.requireLogin,
    dismissLogin: store.dismissLogin,
    goLogin: store.goLogin,
  }
}
